import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import store from "@/store";
import { ElLoading } from 'element-plus'
// import { routes } from '@/util/class/route/route';
import { routes } from './route/base';

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes: routes
})

export const newRouter = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes: routes
});

export default router
